(function ($) {
	'use strict';

	$(function () {
		$('.jsOffcanvasMenuToggler').on('click', function(e) {
			e.preventDefault();

			$('.js-offcanvas-menu-submenu').removeClass('is-active');
			$('.jsOffcanvasMenuNavBackbtn').removeClass('is-active');

			if ( $(this).hasClass('is-active') ) {
				$(this).removeClass('is-active');
				$('.jsOffcanvasMenu').removeClass('is-active');
				$(document.body).removeClass('has-open-menu');
			} else {
				$(this).addClass('is-active');
				$('.jsOffcanvasMenu').addClass('is-active');
				$(document.body).addClass('has-open-menu');
			}
		});

		$(window).on('resize', function() {
			if ( window.matchMedia('(min-width: 1800px)').matches ) {
				$('.jsOffcanvasMenuToggler').removeClass('is-active');
				$('.jsOffcanvasMenu').removeClass('is-active');
				$('.js-offcanvas-menu-submenu').removeClass('is-active');
				$('.jsOffcanvasMenuNavBackbtn').removeClass('is-active');
				$(document.body).removeClass('has-open-menu');
			}
		});

		$('.js-offcanvas-menu-trigger').on('click', function(e) {
			e.preventDefault();

			$(this).next('.js-offcanvas-menu-submenu').addClass('is-active');
			$('.jsOffcanvasMenuNavBackbtn').addClass('is-active');
		});

		$('.jsOffcanvasMenuNavBackbtn').on('click', function(e) {
			e.preventDefault();

			var $submenu = $('.js-offcanvas-menu-submenu.is-active');
			while ( !!$submenu.length ) {
				if ( !$submenu.find('.js-offcanvas-menu-submenu.is-active').length ) {
					$submenu.removeClass('is-active');
					break;
				}

				$submenu = $submenu.find('.js-offcanvas-menu-submenu.is-active');
			}

			if ( !$('.js-offcanvas-menu-submenu.is-active').length )
				$(this).removeClass('is-active');
		});
	});
})(jQuery);
